var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.338,
    height: 19,
    viewBox: "0 0 17.338 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M9.658,3.456l-6.4,7.507a1.768,1.768,0,0,0-.423,1.148v6.955A1.769,1.769,0,0,0,4.6,20.835H6.643a1.769,1.769,0,0,0,1.769-1.769V18.2a1.769,1.769,0,0,1,1.769-1.769h1.646A1.769,1.769,0,0,1,13.6,18.2v.87a1.769,1.769,0,0,0,1.769,1.769H17.4a1.769,1.769,0,0,0,1.769-1.769V12.111a1.768,1.768,0,0,0-.423-1.148l-6.4-7.507A1.769,1.769,0,0,0,9.658,3.456Z",
    transform: "translate(-2.835 -2.835)",
    fill: "none",
    stroke: "#6f6f6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup5);
export default __webpack_public_path__ + "static/media/group-5.c07a04ea285155f606c0342671e3a018.svg";
export { ForwardRef as ReactComponent };